import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const TopFormsByQueryCount = () => {
  const data = [
    {
      form: "Adverse Events",
      total: 165,
      unresolved: 49,
    },
    {
      form: "Laboratory",
      total: 147,
      unresolved: 38,
    },
    {
      form: "Concomitant Medication",
      total: 105,
      unresolved: 31,
    },
    {
      form: "Vital Signs",
      total: 95,
      unresolved: 23,
    },
    {
      form: "Drug Administration",
      total: 67,
      unresolved: 24,
    },
    {
      form: "PK Sample Collection",
      total: 65,
      unresolved: 18,
    },
    {
      form: "ECG",
      total: 57,
      unresolved: 13,
    },
    {
      form: "Medical History",
      total: 56,
      unresolved: 18,
    },
    {
      form: "Physical Examination",
      total: 42,
      unresolved: 9,
    },
    {
      form: "Demographics",
      total: 39,
      unresolved: 6,
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        barHeight: "55%",
      },
    },

    colors: [
      "#cbd5e1", // Total
      "#2563eb", // Unresolved
    ],

    dataLabels: {
      enabled: false,
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
      fontSize: "13px",
    },

    stroke: {
      width: 0,
    },

    xaxis: {
      categories: data.map((item) => item.form),
      min: 0,
      max: 180,
      tickAmount: 9,
    },

    grid: {
      borderColor: "#e2e8f0",
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  const series = [
    {
      name: "Total",
      data: data.map((item) => item.total),
    },
    {
      name: "Unresolved",
      data: data.map((item) => item.unresolved),
    },
  ];

  return (
    <di>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </di>
  );
};

export default TopFormsByQueryCount;
